import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import topologyReducer from './slices/topologySlice.ts';
import simulationReducer from './slices/simulationSlice.ts';
import eventsReducer from './slices/eventsSlice.ts';
import uiReducer from './slices/uiSlice.ts';
import catalogReducer from './slices/catalogSlice.ts';
import schemaReducer from './slices/schemaSlice.ts';
import canvasReducer from './slices/canvasSlice.ts';
import entitlementReducer from './slices/entitlementSlice.ts';
import scenarioSourceReducer from './slices/scenarioSourceSlice.ts';
import walkerSaga from './sagas/walkerSaga.ts';
import suiteSaga from './sagas/suiteSaga.ts';
import scenarioSaga from './sagas/scenarioSaga.ts';
import websocketSaga from './sagas/websocketSaga.ts';
import { catalogSaga } from './sagas/catalogSaga.ts';

export const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    topology: topologyReducer,
    simulation: simulationReducer,
    events: eventsReducer,
    ui: uiReducer,
    catalog: catalogReducer,
    schema: schemaReducer,
    canvas: canvasReducer,
    entitlement: entitlementReducer,
    scenarioSource: scenarioSourceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(walkerSaga);
sagaMiddleware.run(suiteSaga);
sagaMiddleware.run(scenarioSaga);
sagaMiddleware.run(websocketSaga);
sagaMiddleware.run(catalogSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
